export var valuesScormApiVerion = ["Scorm_1_2"];
/*

*/ 
//# sourceMappingURL=ScormApiVerion.js.map